import { index, pgTable, uuid, varchar } from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const sub_hauler = pgTable(
  'sub_hauler',
  {
    ...defaultFields.fieldsWithTenantId(),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    name: varchar('name', { length: 255 }).notNull(),
    email: varchar('email', { length: 255 }),
    sendFromEmail: varchar('sendFromEmail', { length: 255 }),
    phoneNumber: varchar('phoneNumber', { length: 255 }),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
  },
  (table) => {
    return {
      createdAtTs_idx: index('sub_hauler_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('sub_hauler_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('sub_hauler_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('sub_hauler_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('sub_hauler_versionNumber_idx').on(
        table.versionNumber,
      ),
    };
  },
);

export const sub_hauler_history = pgTable('sub_hauler_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  name: varchar('name', { length: 255 }),
  email: varchar('email', { length: 255 }),
  sendFromEmail: varchar('sendFromEmail', { length: 255 }),
  phoneNumber: varchar('phoneNumber', { length: 255 }),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
});
